import { render, staticRenderFns } from "./PdpaFormPanel.vue?vue&type=template&id=6a924e52&scoped=true"
import script from "./PdpaFormPanel.vue?vue&type=script&lang=js"
export * from "./PdpaFormPanel.vue?vue&type=script&lang=js"
import style0 from "./PdpaFormPanel.vue?vue&type=style&index=0&id=6a924e52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a924e52",
  null
  
)

export default component.exports